import React, { ReactElement } from "react";

import { Layout } from "../../../../generated/gql/graphql";
import TextIconButton from "../../../button/text-icon-button";
import AiIcon from "../../../icons/outlines/ai";

import { ComposeLayoutDialog } from "./compose-layout-dialog";

export type ComposeLayoutButtonProps = {
  layout: Pick<Layout, "id" | "renderingProgress" | "status" | "readOnly">;
};

export function ComposeLayoutButton(
  props: ComposeLayoutButtonProps,
): ReactElement {
  const { layout } = props;

  const [showDialog, setShowDialog] = React.useState(false);

  return (
    <>
      <TextIconButton
        label={"AI-Powered Composition"}
        type="primary"
        onClick={async () => {
          // Show a modal to select composition options, then trigger the composition process
          setShowDialog(true);
        }}
        icon={<AiIcon width={16} height={16} />}
      />
      {showDialog && (
        <ComposeLayoutDialog
          layout={layout}
          onClose={() => setShowDialog(false)}
        />
      )}
    </>
  );
}
